import { render, staticRenderFns } from "./price-validation-badge.vue?vue&type=template&id=6e49cc23&scoped=true"
import script from "./price-validation-badge.vue?vue&type=script&lang=js"
export * from "./price-validation-badge.vue?vue&type=script&lang=js"
import style0 from "./price-validation-badge.vue?vue&type=style&index=0&id=6e49cc23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e49cc23",
  null
  
)

export default component.exports